import { render } from "./add-deparment.vue?vue&type=template&id=61ddc984&scoped=true"
import script from "./add-deparment.vue?vue&type=script&lang=js"
export * from "./add-deparment.vue?vue&type=script&lang=js"

import "./add-deparment.vue?vue&type=style&index=0&id=61ddc984&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ddc984"]])

export default __exports__